import { render, staticRenderFns } from "./SettingParticipantFields.vue?vue&type=template&id=2a5575b6&scoped=true"
import script from "./SettingParticipantFields.vue?vue&type=script&lang=js"
export * from "./SettingParticipantFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5575b6",
  null
  
)

export default component.exports